// Simple i18n — Turkish + English. Add languages by extending the dictionaries object.

export type Lang = 'tr' | 'en';

const dict = {
  tr: {
    'app.title': 'ClayForge',
    'app.tagline': 'Açık kaynak kil 3D baskı slicer\'ı',
    'btn.openStl': 'STL Yükle',
    'btn.dropHint': 'STL dosyasını buraya bırak',
    'btn.slice': 'Dilimle ve G-code Üret',
    'btn.export': 'G-code İndir',
    'btn.copy': 'G-code Kopyala',
    'panel.printer': 'Yazıcı',
    'panel.settings': 'Dilimleme Ayarları',
    'panel.preview': '3D Önizleme',
    'panel.gcode': 'G-code',
    'panel.stats': 'İstatistikler',
    'set.layerHeight': 'Katman Yüksekliği (mm)',
    'set.firstLayerHeight': 'İlk Katman Yüksekliği (mm)',
    'set.perimeters': 'Çevre Sayısı',
    'set.infillDensity': 'Dolgu Yoğunluğu (%)',
    'set.infillPattern': 'Dolgu Deseni',
    'set.infillAngle': 'Dolgu Açısı (°)',
    'set.printSpeed': 'Baskı Hızı (mm/dk)',
    'set.firstLayerSpeed': 'İlk Katman Hızı (mm/dk)',
    'set.travelSpeed': 'Boşa Hareket Hızı (mm/dk)',
    'set.vaseMode': 'Vazo Modu (sürekli spiral)',
    'set.bottomLayers': 'Alt Katı Katman Sayısı',
    'set.topLayers': 'Üst Katı Katman Sayısı',
    'stats.layers': 'Katman',
    'stats.timeMin': 'Tahmini süre (dk)',
    'stats.clayMl': 'Tahmini kil (ml)',
    'stats.bbox': 'Sınırlar (mm)',
    'state.noFile': 'Dosya yüklü değil',
    'state.loading': 'Yükleniyor…',
    'state.slicing': 'Dilimleniyor…',
    'state.ready': 'Hazır',
    'view.layerSlider': 'Katman',
    'view.show3d': '3D Model',
    'view.showLayers': 'Dilimler',
    'lang.label': 'Dil',
    'theme.label': 'Tema',
    'theme.dark': 'Koyu',
    'theme.light': 'Açık',
    'pattern.none': 'Yok',
    'pattern.lines': 'Çizgiler',
    'pattern.grid': 'Izgara',
    'pattern.concentric': 'Eş Merkezli',
    'pattern.hilbert': 'Hilbert Eğrisi',
    'panel.insert': 'Ekle',
    'insert.mesh': 'Mesh Modeli',
    'insert.meshExt': '.stl, .obj',
    'insert.vase': 'Vazo Modeli',
    'insert.vaseExt': 'parametrik',
    'insert.gcode': 'G-Code',
    'insert.gcodeExt': '.gcode',
    'insert.spline': '3D Spline',
    'insert.splineExt': '.obj (yakında)',
    'panel.body': 'Gövde',
    'panel.vase': 'Vazo Parametreleri',
    'panel.templates': 'Şablonlar',
    'panel.view': 'Görünüm',
    'tpl.quickClay': 'Hızlı Kil',
    'tpl.detailed': 'Detaylı',
    'tpl.large': 'Büyük Baskı',
    'tpl.solid': 'Dolu Duvarlı',
    'tpl.apply': 'Uygula',
    'mode.edit': 'Düzenle',
    'mode.sculpt': 'Şekillendir',
    'mode.slice': 'Dilimle',
    'mode.preview': 'Önizleme',
    'view.iso': 'İzometrik',
    'view.top': 'Üst',
    'view.front': 'Ön',
    'view.side': 'Yan',
    'view.persp': 'Perspektif',
    'view.frame': 'Sığdır',
    'set.rotateInfill': 'Katman Başına Dolgu Dönüşü (°)',
    'set.scaleInfill': 'Dolgu Ölçeği',
    'set.infillMargin': 'Dolgu Kenar Boşluğu (mm)',
    'vase.segments': 'Çevre Segment Sayısı',
    'vase.rings': 'Yükseklik Halkaları',
    'vase.height': 'Yükseklik (mm)',
    'vase.bottomRadius': 'Taban Yarıçapı (mm)',
    'vase.topRadius': 'Tepe Yarıçapı (mm)',
    'vase.bellyRadius': 'Göbek Yarıçapı (mm)',
    'vase.bellyHeight': 'Göbek Konumu (0–1)',
    'vase.twist': 'Burulma (°)',
    'vase.wallThickness': 'Duvar Kalınlığı (mm)',
    'vase.bottomThickness': 'Taban Kalınlığı (mm)',
    'vase.noiseAmplitude': 'Yüzey Dalga Yüksekliği (mm)',
    'vase.noiseFrequency': 'Yüzey Dalga Sayısı',
    'vase.create': 'Vazoyu Oluştur',
    'vase.update': 'Güncelle',
    'btn.cancel': 'İptal',
    'btn.save': 'Projeyi Kaydet',
    'btn.load': 'Proje Yükle',
    'sculpt.title': 'Şekillendir',
    'sculpt.intro': '3D modele tıklayıp sürükleyerek şekil verin. Kil hamuru gibi çalışır — basıp çekin.',
    'sculpt.brush.pull': 'Çek',
    'sculpt.brush.push': 'İt',
    'sculpt.brush.inflate': 'Şişir',
    'sculpt.brush.pinch': 'Sıkıştır',
    'sculpt.brush.smooth': 'Yumuşat',
    'sculpt.radius': 'Yarıçap',
    'sculpt.strength': 'Güç',
    'sculpt.falloff': 'Kenar Yumuşaklığı',
    'sculpt.symmetryX': 'X-ekseni Simetri',
    'sculpt.undo': 'Geri Al',
    'sculpt.redo': 'İleri Al',
    'sculpt.reset': 'Sıfırla',
    'set.telemetry': 'Anonim Kullanım Verisi (varsayılan kapalı)',
    'project.invalid': 'Geçersiz proje dosyası',
    'project.loaded': 'Proje yüklendi',
    'a11y.closeDialog': 'Pencereyi Kapat'
  },
  en: {
    'app.title': 'ClayForge',
    'app.tagline': 'Open-source clay 3D printing slicer',
    'btn.openStl': 'Open STL',
    'btn.dropHint': 'Drop an STL file here',
    'btn.slice': 'Slice & Generate G-code',
    'btn.export': 'Download G-code',
    'btn.copy': 'Copy G-code',
    'panel.printer': 'Printer',
    'panel.settings': 'Slice Settings',
    'panel.preview': '3D Preview',
    'panel.gcode': 'G-code',
    'panel.stats': 'Stats',
    'set.layerHeight': 'Layer Height (mm)',
    'set.firstLayerHeight': 'First Layer Height (mm)',
    'set.perimeters': 'Perimeters',
    'set.infillDensity': 'Infill Density (%)',
    'set.infillPattern': 'Infill Pattern',
    'set.infillAngle': 'Infill Angle (°)',
    'set.printSpeed': 'Print Speed (mm/min)',
    'set.firstLayerSpeed': 'First Layer Speed (mm/min)',
    'set.travelSpeed': 'Travel Speed (mm/min)',
    'set.vaseMode': 'Vase Mode (continuous spiral)',
    'set.bottomLayers': 'Bottom Solid Layers',
    'set.topLayers': 'Top Solid Layers',
    'stats.layers': 'Layers',
    'stats.timeMin': 'Estimated time (min)',
    'stats.clayMl': 'Estimated clay (ml)',
    'stats.bbox': 'Bounds (mm)',
    'state.noFile': 'No file loaded',
    'state.loading': 'Loading…',
    'state.slicing': 'Slicing…',
    'state.ready': 'Ready',
    'view.layerSlider': 'Layer',
    'view.show3d': '3D Model',
    'view.showLayers': 'Slices',
    'lang.label': 'Language',
    'theme.label': 'Theme',
    'theme.dark': 'Dark',
    'theme.light': 'Light',
    'pattern.none': 'None',
    'pattern.lines': 'Lines',
    'pattern.grid': 'Grid',
    'pattern.concentric': 'Concentric',
    'pattern.hilbert': 'Hilbert Curve',
    'panel.insert': 'Insert',
    'insert.mesh': 'Mesh Model',
    'insert.meshExt': '.stl, .obj',
    'insert.vase': 'Vase Model',
    'insert.vaseExt': 'parametric',
    'insert.gcode': 'G-Code',
    'insert.gcodeExt': '.gcode',
    'insert.spline': '3D Spline',
    'insert.splineExt': '.obj (soon)',
    'panel.body': 'Body',
    'panel.vase': 'Vase Parameters',
    'panel.templates': 'Templates',
    'panel.view': 'View',
    'tpl.quickClay': 'Quick Clay',
    'tpl.detailed': 'Detailed',
    'tpl.large': 'Large Print',
    'tpl.solid': 'Solid Walled',
    'tpl.apply': 'Apply',
    'mode.edit': 'Edit',
    'mode.sculpt': 'Sculpt',
    'mode.slice': 'Slice',
    'mode.preview': 'Preview',
    'view.iso': 'Isometric',
    'view.top': 'Top',
    'view.front': 'Front',
    'view.side': 'Side',
    'view.persp': 'Perspective',
    'view.frame': 'Frame',
    'set.rotateInfill': 'Rotate Infill Each Layer (°)',
    'set.scaleInfill': 'Scale Infill',
    'set.infillMargin': 'Infill Margin (mm)',
    'vase.segments': 'Segments',
    'vase.rings': 'Rings',
    'vase.height': 'Height (mm)',
    'vase.bottomRadius': 'Bottom Radius (mm)',
    'vase.topRadius': 'Top Radius (mm)',
    'vase.bellyRadius': 'Belly Radius (mm)',
    'vase.bellyHeight': 'Belly Position (0–1)',
    'vase.twist': 'Twist (°)',
    'vase.wallThickness': 'Wall Thickness (mm)',
    'vase.bottomThickness': 'Bottom Thickness (mm)',
    'vase.noiseAmplitude': 'Surface Ripple Height (mm)',
    'vase.noiseFrequency': 'Surface Ripple Count',
    'vase.create': 'Create Vase',
    'vase.update': 'Update',
    'btn.cancel': 'Cancel',
    'btn.save': 'Save Project',
    'btn.load': 'Load Project',
    'sculpt.title': 'Sculpt',
    'sculpt.intro': 'Click and drag on the 3D model to shape it. Works like clay — push and pull.',
    'sculpt.brush.pull': 'Pull',
    'sculpt.brush.push': 'Push',
    'sculpt.brush.inflate': 'Inflate',
    'sculpt.brush.pinch': 'Pinch',
    'sculpt.brush.smooth': 'Smooth',
    'sculpt.radius': 'Radius',
    'sculpt.strength': 'Strength',
    'sculpt.falloff': 'Edge Softness',
    'sculpt.symmetryX': 'X-axis Symmetry',
    'sculpt.undo': 'Undo',
    'sculpt.redo': 'Redo',
    'sculpt.reset': 'Reset',
    'set.telemetry': 'Anonymous Usage Data (default off)',
    'project.invalid': 'Invalid project file',
    'project.loaded': 'Project loaded',
    'a11y.closeDialog': 'Close dialog'
  }
} as const;

type Key = keyof (typeof dict)['en'];

export function t(lang: Lang, key: Key): string {
  return dict[lang][key] ?? dict.en[key] ?? key;
}

export function detectInitialLang(): Lang {
  if (typeof navigator === 'undefined') return 'en';
  const saved = localStorage.getItem('clayforge.lang');
  if (saved === 'tr' || saved === 'en') return saved;
  return navigator.language.toLowerCase().startsWith('tr') ? 'tr' : 'en';
}
